import { DateTime } from 'luxon';

export const getLocalDateTime = (
  isoDateString: string,
  month: 'short' | 'long' = 'short',
): {
  date: string;
  time: string;
} | null => {
  if (!isoDateString) return null;
  try {
    // Parse the ISO string directly using luxon
    const gameDateTime = DateTime.fromISO(isoDateString, { zone: 'UTC' });
    if (!gameDateTime.isValid) return null;
    // Convert to local time
    const localDateTime = gameDateTime.toLocal();
    // Format in local time with both date and time, using a fixed locale to prevent hydration errors
    return {
      date: localDateTime.toLocaleString(
        {
          month,
          day: 'numeric',
          year: 'numeric',
        },
        { locale: 'en-US' },
      ),
      time: localDateTime.toLocaleString(
        {
          hour: 'numeric',
          minute: '2-digit',
          timeZoneName: 'short',
        },
        { locale: 'en-US' },
      ),
    };
  } catch (error) {
    console.error('Error formatting game time:', error);
    return null;
  }
};
